'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var React = require('react');
require('@emotion/react');
require('../../../../../../node_modules/@fortawesome/react-fontawesome/index.es.cjs');
require('../../../../../../_virtual/index.cjs');
var InternalButtonLink_web = require('../../internal/InternalButtonLink/InternalButtonLink.web.cjs');
require('../../../utils/AviaryProvider/AviaryThemeContext.cjs');
require('../../../../../../_virtual/index2.cjs');
require('aviary-tokens');
require('../../atoms/Typography/Typography.web.cjs');
require('../../internal/InternalToggle/InternalToggle.web.cjs');
var BottomBar_web = require('./BottomBar/BottomBar.web.cjs');
var CoreActions_web = require('./CoreActions/CoreActions.web.cjs');
var Info_web = require('./Info/Info.web.cjs');
var Media_web = require('./Media/Media.web.cjs');
var Price_web = require('./Price/Price.web.cjs');
var TopBar_web = require('./TopBar/TopBar.web.cjs');
var VariantDropdown_web = require('./VariantDropdown/VariantDropdown.web.cjs');
var ProductCard_web_styles = require('./ProductCard.web.styles.cjs');

/**
 * A Composable card component for anything that can be added to a plan or cart
 * ex: supplements, resources, labs, plan templates.
 *
 * {@link https://aviary.fullscript.io/latest/components/product-card-1-2/web-5UAaRksg | Documentation}
 *
 * {@link https://git.fullscript.io/developers/aviary/-/blob/development/packages/aviary-web/src/components/platform/ProductCard/ProductCard.web.tsx | View in GitLab}
 *
 * @scope Core
 */ const ProductCard = ({ children, onCardClick, isLoading = false, isFullWidth = false, isBorderless = false, to, href, ...rest })=>{
    const renderCompareCheckedStyles = ()=>{
        const hasCompareChecked = React.Children.toArray(children).some((child)=>{
            if (/*#__PURE__*/ React.isValidElement(child) && child.type === BottomBar_web.BottomBar) {
                const bottomBarProps = child.props;
                return bottomBarProps.isCompareChecked;
            }
            return false;
        });
        return hasCompareChecked ? ProductCard_web_styles.compareChecked : undefined;
    };
    const wrapperStyles = [
        ProductCard_web_styles.productCard,
        isFullWidth && ProductCard_web_styles.fullWidth,
        renderCompareCheckedStyles(),
        isBorderless && ProductCard_web_styles.borderless
    ];
    const renderProductName = ()=>{
        return React.Children.map(children, (child)=>{
            if (/*#__PURE__*/ React.isValidElement(child) && child.type === Info_web.Info) {
                const infoProps = child.props;
                if (infoProps.name) {
                    return infoProps.name;
                }
            }
        });
    };
    const renderVariant = ()=>{
        return React.Children.map(children, (child)=>{
            if (/*#__PURE__*/ React.isValidElement(child) && child.type === VariantDropdown_web.VariantDropdown) {
                const variantProps = child.props;
                if (variantProps.variants) {
                    const currentVariant = variantProps.variants.find((variant)=>variant.id === variantProps.currentVariantId) || variantProps.variants[0];
                    return currentVariant.descriptor;
                }
            }
        });
    };
    const renderChild = (childType)=>{
        return React.Children.map(children, (child)=>{
            if (/*#__PURE__*/ React.isValidElement(child) && child.type === childType) {
                if (isLoading) {
                    const childProps = Object.assign({}, child.props, {
                        isLoading: true
                    });
                    return /*#__PURE__*/ React.cloneElement(child, childProps);
                }
                if (child.type === Media_web.Media) {
                    const productName = renderProductName()?.join("") || "";
                    const variant = renderVariant()?.join("") || "";
                    const alt = `${productName} ${variant}`.trim();
                    return /*#__PURE__*/ React.cloneElement(child, {
                        alt,
                        ...child.props
                    });
                }
                return child;
            }
        });
    };
    return /*#__PURE__*/ jsxRuntime.jsxs("div", {
        css: wrapperStyles,
        "aria-busy": isLoading,
        children: [
            (to || href || onCardClick) && !isLoading && /*#__PURE__*/ jsxRuntime.jsx(InternalButtonLink_web.InternalButtonLink, {
                onClick: onCardClick,
                "aria-label": renderProductName()?.toString(),
                to: to,
                href: href,
                ...rest,
                css: ProductCard_web_styles.productCardLink
            }),
            renderChild(TopBar_web.TopBar),
            /*#__PURE__*/ jsxRuntime.jsxs("div", {
                css: ProductCard_web_styles.innerWrapper,
                children: [
                    renderChild(Media_web.Media),
                    renderChild(Info_web.Info),
                    renderChild(VariantDropdown_web.VariantDropdown),
                    renderChild(Price_web.Price),
                    renderChild(CoreActions_web.CoreActions),
                    renderChild(BottomBar_web.BottomBar)
                ]
            })
        ]
    });
};
/**
 * Subcomponent of ProductCard, displays metadata about the product or service and secondary actions
 *
 * @requires ProductCard
 *
 * @scope Web
 */ ProductCard.TopBar = TopBar_web.TopBar;
/**
 * Subcomponent of ProductCard, displays the visual for the card
 *
 * @requires ProductCard
 *
 * @scope Web
 */ ProductCard.Media = Media_web.Media;
/**
 * Subcomponent of ProductCard, displays the name and brand/author of the product or service
 *
 * @requires ProductCard
 *
 * @scope Web
 */ ProductCard.Info = Info_web.Info;
/**
 * Subcomponent of ProductCard, displays a dropdown for variants and availability status of a product
 *
 * @requires ProductCard
 *
 * @scope Web
 */ ProductCard.VariantDropdown = VariantDropdown_web.VariantDropdown;
/**
 * Subcomponent of ProductCard, displays the cost of a product or service
 *
 * @requires ProductCard
 *
 * @scope Web
 */ ProductCard.Price = Price_web.Price;
/**
 * Subcomponent of ProductCard, displays core action(s) for the card
 *
 * @requires ProductCard
 *
 * @scope Web
 */ ProductCard.CoreActions = CoreActions_web.CoreActions;
/**
 * Subcomponent of ProductCard, displays warnings and compare checkbox
 *
 * @requires ProductCard
 *
 * @scope Web
 */ ProductCard.BottomBar = BottomBar_web.BottomBar;

exports.ProductCard = ProductCard;
//# sourceMappingURL=ProductCard.web.cjs.map
